module.exports = __webpack_public_path__ + "img/Logo-29.32e84228.svg";